export default "__VITE_ASSET__DPL0E7lz__"